import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box } from '@eatclubapp/ec-component-library';

const FONT_GROTESQUE = "'General Grotesque', Inter, 'Helvetica', 'sans-serif'";
const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';

const tabButtonBase = {
  position: 'relative',
  zIndex: 1,
  textAlign: 'center',
  padding: '5px 8px',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: FONT_GROTESQUE,
  color: '#313131',
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  boxShadow: 'none',
  minWidth: 0,
};

const TAB_TRACK = '164px';
/** Slightly more space for "Customers" than "Offers" (40% / 60% of inner width after horizontal padding) */
const OFFER_SHARE = 0.4;

/**
 * Segmented Offers / Customers control (Figma: inline with page title).
 * Native buttons do not inherit portal typography; font is set here.
 */
const OfferPerformanceSegmentedTabs = () => {
  const history = useHistory();
  const location = useLocation();
  const isCustomers = location.pathname.startsWith('/insights/customers');

  const inner = `100% - 8px`;
  const pillNarrowW = `calc((${inner}) * ${OFFER_SHARE})`;
  const pillWideW = `calc((${inner}) * ${1 - OFFER_SHARE})`;

  return (
    <Box
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'stretch',
        margin: '10px 0px 0px 14px',
        padding: '3px 4px',
        borderRadius: '11px',
        backgroundColor: '#EDE6DB',
        width: TAB_TRACK,
        minWidth: TAB_TRACK,
        flexShrink: 0,
        height: '36px',
        boxSizing: 'border-box',
      }}
      role='tablist'
      aria-label='Offer performance views'
    >
      <Box
        style={{
          position: 'absolute',
          top: '3px',
          height: 'calc(100% - 6px)',
          left: isCustomers ? `calc(4px + (${inner}) * ${OFFER_SHARE})` : '4px',
          width: isCustomers ? pillWideW : pillNarrowW,
          borderRadius: '8px',
          backgroundColor: '#fff',
          boxShadow: '0px 4px 2px rgba(187, 187, 187, 0.25)',
          transition: `left 0.3s ${EASE}, width 0.3s ${EASE}, box-shadow 0.3s ${EASE}`,
          pointerEvents: 'none',
        }}
        aria-hidden
      />
      <button
        type='button'
        role='tab'
        aria-selected={!isCustomers}
        onClick={() => history.push('/insights')}
        style={{
          ...tabButtonBase,
          flex: '2 1 0%',
        }}
      >
        Offers
      </button>
      <button
        type='button'
        role='tab'
        aria-selected={isCustomers}
        onClick={() => history.push('/insights/customers')}
        style={{
          ...tabButtonBase,
          flex: '3 1 0%',
          padding: '5px 10px',
        }}
      >
        Customers
      </button>
    </Box>
  );
};

export default OfferPerformanceSegmentedTabs;
